module.exports = __webpack_public_path__ + "fonts/iconfont.2bef5f81.woff2";